module.exports = __webpack_public_path__ + "img/blacklogo.9eb89abe.png";